
































































import Vue from 'vue';
import '@/lib/log';

import { defineComponent, reactive, toRefs } from '@vue/composition-api';
import { useOrganization, OrganizationModel } from '@/module/organization';

const { selectItem: selectOrganization, createConnKey } = useOrganization();

const state = reactive({
  connKeyDialog: false,
  connKey: '',
  expiresInDays: 365,
  generated: false,
  organization: {}
});

const reset = () => {
  state.connKey = '';
  state.organization = {};
  state.generated = false;
};

const close = () => {
  state.connKeyDialog = false;
  reset();
};

const showConnCredentialsForm = (id: string) => {
  selectOrganization(id).then((o: OrganizationModel) => {
    state.organization = { ...o };
    state.connKeyDialog = true;
    Vue.$log.debug('Selected org: ', state.organization);
  });
  Vue.$log.debug('Showing Connector credentials form. Current state: ', state);
};

export function useConnCredentialsForm() {
  return { showConnCredentialsForm };
}

export default defineComponent({
  name: 'ConnCredentialsForm',

  setup() {
    const generateKey = (id: string) => {
      createConnKey(id, state.expiresInDays).then((key: string) => {
        state.connKey = key;
        state.generated = true;
      });
    };

    return { ...toRefs(state), close, generateKey };
  }
});
